'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';

const __endpoints = require('endpoints.service');

export default class StoreLocationTypes extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
			{
				name: 'sort_order',
				type: 'number',
				canAdd: true,
				canEdit: true,
			},
		];
		this.settings = {
			name: 'StoreLocationTypes',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			canManipulate: () => validAccess(undefined, ['Global BI Configuration']),
			translationPath: 'ADMINISTRATION.STORE_LOCATION_TYPES',
			endpoint: __endpoints.collection.administration.store_location_types,
		};
		this.init();
		return this;
	}
}
